import React, { useState } from 'react'
import { useNavigate, Link, Navigate } from 'react-router-dom'
import './css/index.css'
import { logout } from './lib/allauth'
import FormErrors from './components/FormErrors'

export default function Logout () {
  const [response, setResponse] = useState({ fetching: false, content: null })
  const navigate = useNavigate()

  function submit () {
    setResponse(r => ({ ...r, fetching: true }))
    logout()
      .then(content => {
        setResponse(r => ({ ...r, content }))
      })
      .catch(e => {
        console.error(e)
        window.alert(e)
      })
      .finally(() => {
        setResponse(r => ({ ...r, fetching: false }))
      })
  }

  if (response.content && !response.content.errors) {
    return <Navigate to="/" replace />
  }

  return (
    <>
      <header className="top-bar">
        <div className="logo-section">
          <div className="logo-wrapper">
            <img
              src={require('./img/svk.png')}
              alt="Scoutkåren logo"
              className="logo-img"
            />
            <div className="logo-bubble">Under konstruktion! 🌲</div>
          </div>
        </div>

        <nav className="nav-buttons">
          <Link to="/" className="nav-btn secondary">
            Tillbaka till framsidan
          </Link>
        </nav>
      </header>

      <div className="login-page">
        <FormErrors errors={response.content?.errors} />

        <div className="login-card">
          <p>Vill du logga ut?</p>

          <button
            onClick={submit}
            className="login-button logout"
            disabled={response.fetching}
          >
            Logga ut
          </button>

        
        </div>
      </div>
    </>
  )
}